import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

import { citationPrestigeList } from './../../model/CitationTypes';

export type CitationPrestigeSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function CitationPrestigeSelectControl<T extends FieldValues>(props: CitationPrestigeSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(
    () => citationPrestigeList.map(c => ({ value: c, label: t(`citations.prestigeEnum.${c}`) })),
    [t],
  );

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
